// =============================================================================
// Firebase Web — init + Cloud Messaging (Web Push pour le dashboard admin)
// -----------------------------------------------------------------------------
// La config Firebase "web" n'est PAS secrète (elle est de toute façon exposée
// côté client). On la lit depuis les variables REACT_APP_FIREBASE_* si elles
// existent, sinon on tombe sur les placeholders ci-dessous.
//
// ⚠️ À REMPLIR (Console Firebase → Project Settings) :
//   1. Config web   : Your apps → app Web </> → "SDK setup and configuration"
//   2. Clé VAPID    : Cloud Messaging → Web Push certificates → Generate key pair
//
// ⚠️ La MÊME config web doit être recopiée dans public/firebase-messaging-sw.js
//    (un service worker ne peut pas lire process.env).
// =============================================================================

import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

// Fallbacks = vraies valeurs (config web Firebase NON secrète) pour que ça
// marche en dev ET en prod même si les variables d'env ne sont pas chargées.
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDBIZBwiWoUxGbS9BdsTwey46_PzGO3Yy8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "batilink-3ea41.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "batilink-3ea41",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "486787690830",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:486787690830:web:cb71a7ae01edba9da1ee1f",
};

// Clé VAPID (Web Push certificate) — obligatoire pour getToken() côté web.
export const VAPID_KEY =
  process.env.REACT_APP_FIREBASE_VAPID_KEY ||
  "BDnjRLNTEgy1Yrmdrpjm4jEoL-GIDgIY_Dprrq6ZMD7zUyYwVd_8-GY-Dxoy4qmZISRUfYgzLBVpMRXXOqXFsak";

let _app = null;
let _messaging = null;

function getApp() {
  if (!_app) _app = initializeApp(firebaseConfig);
  return _app;
}

/**
 * Retourne l'instance Messaging si le navigateur la supporte, sinon null.
 * (Safari < 16, navigateurs sans service worker, contextes non sécurisés…)
 */
export async function getMessagingIfSupported() {
  try {
    if (!(await isSupported())) return null;
    if (!_messaging) _messaging = getMessaging(getApp());
    return _messaging;
  } catch {
    return null;
  }
}

export { getToken, onMessage };
